(function(global){
  'use strict';
  function range(value){
    const s=String(value??'').trim().replace(/\u00a0/g,' ').replace(/,/g,'.');
    const m=s.match(/^(\d+(?:\.\d+)?)\s*[-–—−]\s*(\d+(?:\.\d+)?)\s*(?:cm)?$/i);
    if(!m)return null;
    const min=Number(m[1]),max=Number(m[2]);
    return min>0&&max>=min?{min,max}:null;
  }
  function choose(rows,values){
    const keys=['hips','waist'].filter(k=>values[k]!==''&&values[k]!=null);
    if(!keys.length)return {state:'empty',rows:[]};
    if(keys.some(k=>!Number.isFinite(Number(values[k]))||Number(values[k])<=0))return {state:'invalid',rows:[]};
    const primary=keys.includes('hips')?'hips':'waist';
    const parsed=rows.map((row,index)=>({...row,index,hips:range(row.hips),waist:range(row.waist)})).filter(row=>row[primary]);
    if(!parsed.length)return {state:'unavailable',rows:[]};
    const value=Number(values[primary]);
    const lower=Math.min(...parsed.map(r=>r[primary].min)),upper=Math.max(...parsed.map(r=>r[primary].max));
    if(value<lower||value>upper)return {state:'outside',rows:[]};
    let matches=parsed.filter(r=>value>=r[primary].min&&value<=r[primary].max);
    let reason='interval';
    if(!matches.length){
      // A gap within the chart advances to the next listed interval; never extrapolate beyond it.
      const next=Math.min(...parsed.filter(r=>r[primary].min>value).map(r=>r[primary].min));
      matches=parsed.filter(r=>r[primary].min===next);reason='gap';
    }
    const distance=(interval,n)=>interval?Math.max(interval.min-n,0,n-interval.max):Infinity;
    // Waist distinguishes overlapping hip candidates; it cannot veto a hip match.
    matches.sort((a,b)=>{
      if(primary==='hips'&&keys.includes('waist')){
        const da=distance(a.waist,Number(values.waist)),db=distance(b.waist,Number(values.waist));
        if(da!==db)return da<db?-1:1;
      }
      return b[primary].min-a[primary].min||b[primary].max-a[primary].max||a.index-b.index;
    });
    return {state:'match',rows:[matches[0]],reason};
  }

  if(typeof module!=='undefined'&&module.exports){module.exports={range,choose};return;}
  if(global.__femiekoSizeGuideV2){global.__femiekoSizeGuideV2.init(document);return;}
  function bind(section){
    if(section.dataset.chSizeReady==='true')return;
    section.dataset.chSizeReady='true';
    const buttons=[...section.querySelectorAll('[data-ch-measure]')];
    function select(key){
      if(!['waist','hips'].includes(key))return;
      section.dataset.photoActive=key;
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.chMeasure===key)));
      section.querySelectorAll('[data-ch-instruction]').forEach(p=>p.hidden=p.dataset.chInstruction!==key);
    }
    buttons.forEach(b=>b.addEventListener('click',()=>select(b.dataset.chMeasure)));
    const image=section.querySelector('.ch-size-photo__image');
    if(image){
      function failed(){section.querySelector('[data-ch-photo-panel]').hidden=true;section.classList.remove('ch-size--with-photo');buttons.filter(b=>b.classList.contains('ch-size__column-btn')).forEach(b=>b.disabled=true);}
      image.addEventListener('error',failed,{once:true});
      if(image.complete&&image.naturalWidth===0)failed();
    }
    const form=section.querySelector('.ch-ff');
    if(!form)return;
    const inputs={waist:form.querySelector('.ch-ff__waist'),hips:form.querySelector('.ch-ff__hip')};
    const result=form.querySelector('.ch-ff__result'),sizeOut=form.querySelector('.ch-ff__size'),copyOut=form.querySelector('.ch-ff__txt');
    const rows=[...section.querySelectorAll('.ch-size__table tbody tr')].map((el,index)=>({el,index,size:el.dataset.size,hips:el.dataset.hip,waist:el.dataset.waist}));
    function reset(){rows.forEach(r=>r.el.classList.remove('is-hl'));result.hidden=true;sizeOut.textContent='';Object.values(inputs).forEach(i=>i.removeAttribute('aria-invalid'));}
    for(const [key,input] of Object.entries(inputs)){input.addEventListener('focus',()=>select(key));input.addEventListener('input',reset);}
    form.addEventListener('submit',event=>{
      event.preventDefault();reset();
      const values=Object.fromEntries(Object.entries(inputs).map(([k,input])=>[k,input.validity.badInput?NaN:input.value]));
      const found=choose(rows,values);
      result.hidden=false;result.dataset.state=['match','overlap'].includes(found.state)?found.state:'error';
      if(found.state==='match'||found.state==='overlap'){
        found.rows.forEach(r=>r.el.classList.add('is-hl'));
        sizeOut.textContent=found.rows.map(r=>r.size).join(' / ');
        copyOut.textContent=found.state==='match'?copyOut.dataset.successMessage:form.dataset.overlapMessage;
      }else{
        copyOut.textContent=form.dataset[found.state+'Message'];
        if(found.state==='invalid')for(const [key,input] of Object.entries(inputs))if(values[key]!==''&&(!Number.isFinite(Number(values[key]))||Number(values[key])<=0))input.setAttribute('aria-invalid','true');
      }
    });
  }
  function init(root){if(root.matches?.('[data-ch-size-v2]'))bind(root);root.querySelectorAll('[data-ch-size-v2]').forEach(bind);}
  global.__femiekoSizeGuideV2={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})(typeof window==='undefined'?globalThis:window);
